import { computed, observable } from "mobx";
import FormStore from "~/stores/FormStore";
import CreditCardStore from "~/stores/Credit/CreditCardStore";
import InvoiceStore from "~/stores/Invoice/InvoiceStore";
import InvoicePaymentStore from "~/stores/Invoice/InvoicePaymentStore";
import CreditHelper from "~/utils/CreditHelper";

class InvoicePageStore {
  @observable invoiceStore = null;

  @observable invoicePaymentStore = null;

  @observable formStore = null;

  @observable creditCardStore = null;

  constructor() {
    this.invoiceStore = new InvoiceStore();
    this.invoicePaymentStore = new InvoicePaymentStore();
    this.formStore = new FormStore();
    this.creditCardStore = new CreditCardStore();
  }

  @computed
  get creditCardId() {
    const { model } = this.formStore;

    return model.creditCardId !== "" ? parseInt(model.creditCardId, 10) : null;
  }

  @computed
  get creditCardOptions() {
    const { creditCards } = this.creditCardStore;

    return CreditHelper.getCreditCardOptions(creditCards);
  }
}

export default InvoicePageStore;
